import React from "react";
import { Switch, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import informationButton from "../../../../assets/information-button.svg";
import { getPaneIndex } from "../../../../redux/constants";
import { setY_attribute } from "../../../../redux/actions/WidgetMaker/GraphConfig";

const CountSourceToggle = ({ section_index, widget_index }) => {
  const dispatch = useDispatch();
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const index = getPaneIndex(panes, activeKey);

  let pathName = window.location.pathname?.split("/")?.[1];

  let total_count_flag =
    panes?.[index]?.is_widget_maker_open_obj?.open_flag ||
    pathName === "widgetMaker" ||
    pathName === "edit-widget"
      ? widgetGraphConfig?.chart_settings?.total_count_flag
      : shareTemplateData
      ? shareTemplateData?.sections
        ? shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
            ?.chart?.chart_settings?.total_count_flag
        : shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.chart
            ?.chart_settings?.total_count_flag
      : panes?.[index]?.sections
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
          ?.chart?.chart_settings?.total_count_flag
      : panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.chart
          ?.chart_settings?.total_count_flag;

  const handleChangeToggle = (checked) => {
    if (
      panes?.[index]?.is_widget_maker_open_obj?.open_flag ||
      pathName === "widgetMaker" ||
      pathName === "edit-widget"
    ) {
      // in widget maker mode
      dispatch(
        setY_attribute({
          ...widgetGraphConfig,
          deep_dive_on: null,
          chart_settings: {
            ...widgetGraphConfig?.chart_settings,
            total_count_flag: checked,
          },
        })
      );
    } else if (shareTemplateData) {
      // in share template mode
      let updateShareTemplateData = { ...shareTemplateData };
      if (updateShareTemplateData?.sections) {
        updateShareTemplateData.sections[section_index].widgets[
          widget_index
        ].deep_dive_on = null;
        updateShareTemplateData.sections[section_index].widgets[
          widget_index
        ].chart.chart_settings.total_count_flag = checked;
        updateShareTemplateData.sections[section_index].widgets[
          widget_index
        ].graphData = null;
      } else {
        updateShareTemplateData.section[0].widgets[widget_index].deep_dive_on =
          null;
        updateShareTemplateData.section[0].widgets[
          widget_index
        ].chart.chart_settings.total_count_flag = checked;
        updateShareTemplateData.section[0].widgets[widget_index].graphData =
          null;
      }
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: updateShareTemplateData,
      });
    } else {
      // in Dashboard mode
      let updatePanes = [...panes];
      if (updatePanes?.[index]?.sections) {
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].deep_dive_on = null;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].chart.chart_settings.total_count_flag = checked;
        updatePanes[index].sections[section_index].widgets[
          widget_index
        ].graphData = null;
      } else {
        updatePanes[index].section[0].widgets[widget_index].deep_dive_on = null;
        updatePanes[index].section[0].widgets[
          widget_index
        ].chart.chart_settings.total_count_flag = checked;
        updatePanes[index].section[0].widgets[widget_index].graphData = null;
      }
      dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}>
      <Tooltip
        title={
          total_count_flag
            ? "Switch to relative count mode"
            : "Switch to total count mode"
        }
      >
        <Switch
          checked={total_count_flag}
          loading={false}
          onChange={handleChangeToggle}
        />
      </Tooltip>
      <Tooltip
        placement="top"
        title={
          <span>
            Toggle Modes:
            <br />
            <br />
            OFF (Relation Counts): Shows counts specific to the relationships
            between nodes – displaying how many interactions/mentions occur in
            the context of connected brands or categories.
            <br />
            <br />
            ON (Total Counts): Shows aggregate counts for each node
            independently – displaying the total volume of mentions/interactions
            for each brand or category across all contexts, regardless of their
            relationships to other nodes.
          </span>
        }
      >
        <img
          src={informationButton}
          alt="Info"
          className="cursor-pointer ml-2"
          style={{ maxWidth: "1.6rem" }}
        />
      </Tooltip>
    </div>
  );
};

export default CountSourceToggle;
